"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _PositionHistoryComponent = _interopRequireDefault(require("./PositionHistoryComponent"));
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _selectors = require("../../../redux/margin/selectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var closedPositions = (0, _selectors.closedPositionsSelector)(state, ownProps.config);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var notionalProductSymbol = (0, _productsSelectors.baseNotionalProductSymbolSelector)(state);
  var activeRequests = state.margin.history.activeRequests;
  var fetching = activeRequests > 0;
  return {
    data: closedPositions,
    instruments: instruments,
    notionalProductSymbol: notionalProductSymbol,
    fetching: fetching
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_PositionHistoryComponent["default"]);